import theme from "../../theme";

export default function isMobileView() {
  return theme.breakpoints.isMobileView(window.innerWidth);
}